import { FormArray, FormControlStatus, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';

export interface IFormOptions {
  onlySelf?: boolean | undefined;
  emitEvent?: boolean | undefined;
}

export interface ErrorFormat {
  [key: string]: boolean;
}

export interface IEmbeddableForm {
  ADD: presentInMode;
  REPAIR: presentInMode;
  VIEW: presentInMode;
  DECISION: presentInMode;
  MODIFY: any;
}

export type presentInMode = (data: string) => void;

export interface IDataLoadOptions {
  referenceDetails: any;
}

export interface IViewModeOptions extends IDataLoadOptions {}

export interface IEntryModeOptions {}

export interface IRepairModeOptions extends IDataLoadOptions {
  repairableFields: string[];
  repairableFieldComments: Map<string, string>;
}

export interface IApprovalModeOptions extends IDataLoadOptions {}

export interface INavigateState {
  presentMode: TNavigation;
}

export enum ENavigateState {
  ENTRY_SHELL = 'ENTRY',
  DECISION_SHELL = 'DECISION',
  REPAIR_SHELL = 'REPAIR',
  VIEW_SHELL = 'VIEW',
}

export type TNavigation = 'VIEW' | 'REPAIR' | 'ADD' | 'DECISION' | 'MODIFY';

export interface BaseFpxChangeHandler {
  (
    name: string,
    status: FormControlStatus,
    value: any,
    formGroup: FormGroup
  ): void;
}

export interface BaseFpxGridChangeHandler {
  (
    name: string,
    status: FormControlStatus,
    value: any,
    formGroup: FormArray,
    index: number
  ): void;
}

export interface BaseFpxLoadFormHandler<T> {
  (transactionRefNo: string, formGroup: FormGroup, context: T): void;
}

export interface BaseFpxEventHandler {
  (payload :any): void;
}
